import { createFileRoute, redirect } from '@tanstack/react-router'
import { PaymentDetailScreen } from '@/features/accounting-payments/payment-detail-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for one payment.
 *
 * The grant guard is `accounting_payment.view`, the same key as the list.
 * Whether the caller may see THIS payment is the API's answer, not the
 * browser's: tenancy scoping makes another company's payment a 404, and the
 * screen surfaces that rather than deciding it here.
 */
export const Route = createFileRoute('/_authenticated/accounting/payments/$paymentId')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_payment.view')) {
      throw redirect({ to: '/accounting/payments' })
    }
  },
  component: AccountingPaymentDetailRoute,
})

function AccountingPaymentDetailRoute() {
  const { paymentId } = Route.useParams()

  return <PaymentDetailScreen paymentId={paymentId} />
}
